import { IncompleteLeadIDResponse } from 'domains/signupDirect/ResumeLead/data/types';
import { deepReplaceNullsWithUndefined } from 'utils/object';

/** Replaces all null values with undefined for easier usage */
export const normalizeResumeLeadData = (data: IncompleteLeadIDResponse): IncompleteLeadIDResponse => {
  return deepReplaceNullsWithUndefined(data);
};
